import React from 'react';
import { useNavigate } from 'react-router-dom';
import './EnrollPopup.css';

interface EnrollPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const EnrollPopup: React.FC<EnrollPopupProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  if (!isOpen) return null;

  return (
    <div className="enroll-popup-overlay" onClick={onClose}>
      <div className="enroll-popup" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={onClose}>✕</button>
        <div className="popup-icon">🔒</div>
        <h2 className="popup-title">Login Required</h2>
        <p className="popup-message">
          Please login to enroll in this course. Create an account if you don't have one yet.
        </p>
        <div className="popup-buttons">
          <button className="popup-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="popup-login" onClick={handleLogin}>
            Go to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnrollPopup;

